export default {
  //存储数据
  state: {
    isCollapse: false,
    // currentMenu: null,
    searchBeginEnd:[],
    visitedTab:[],
    refresh_data:{
      refresh_status: false,
      value_time: 5000,
    }
    
  },
  getters:{
    getSearchDate(state){
      return state.searchBeginEnd;
    },
    getRefreshData(state){
      return state.refresh_data;
    }
  },
  //调用方法
  mutations: {
    collapse(state) {
      // 菜单折叠控制开关
      state.isCollapse = !state.isCollapse;
    },
    setSearchDate(state,date){
      // 设置ES默认搜索区间
      state.searchBeginEnd = date;
    },
    setRefreshData(state,data){
      // 设置ES默认搜索区间
      state.refresh_data = data;
    },
    setVisitedTab(state,data){
      // 设置标签页数据
      state.visitedTab = data;
    }
  },
  actions: {
      setSearchDate({commit,state},date){
        commit('setSearchDate',date)
      },
      setVisitedTab({commit,state},data){
        commit('setVisitedTab',data)
      },
      setRefreshData({commit,state},data){
        commit('setRefreshData',data)
      },
  },
};
